new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  created: function () {
    window.addEventListener('resize', this.handleViewport)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.handleViewport)
  },
  mounted: function () {
    this.handleViewport()
  },
  methods: {
    handleViewport: function () {
      var mobile = window.matchMedia('(max-width: 767px)').matches
      this.$actions.setViewport(mobile ? 'mobile' : 'desktop')
    }
  }
})
